import { useEffect, useState } from "react";

/**
 * Hook to listen to document visibility changes.
 *
 * Returns `true` if the document is visible, and `false` if it is hidden.
 * Uses the Page Visibility API.
 *
 * @returns boolean
 */
export function useDocumentVisibilityChange() {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === "visible");
    };

    // Check initial state
    handleVisibilityChange();

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isVisible;
}
